<template lang="pug">

  section.crossfit
    h1(data-aos="fade-right" data-aos-delay="300" data-aos-once="true") CROSSFIT
    .text.text1
      Texto(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
        h2 Las mujeres entran en masa al Crossfit
        p Las mujeres destacan diariamente en diversos ámbitos como el profesional, laboral y deportivo. Así también, muchas deben compatibilizar sus tiempos para dar lo mejor de sí mismas en todas estas áreas y demostrar que son capaces de conseguir todo lo que se proponen. Sin embargo, una parte fundamental es sentirse cómodas, y para ello la elección de las zapatillas es esencial, ya que con ellas no solo realizarán sus distintos quehaceres, sino que también podrán practicar su actividad física favorita con una comodidad inigualable y luciendo siempre en tendencia.

        p Dentro de las categorías, muchas son las que optan por deportes de contacto y alta carga física, como por ejemplo: el CrossFit. Es por esto que contar con un calzado adecuado que te brinde estilo, tendencia y a la vez comodidad es indispensable. Para ello, Skechers cuenta con la línea SPORT que se caracteriza por sus zapatillas multifuncionales, ultralivianas y la icónica tecnología Skechers Memory Foam, que entrega una gran amortiguación. Además, esta línea cuenta con modelos con malla entramada Skech Knit, un tejido respirable y cómodo que permite total movilidad de tus dedos, especialmente para una disciplina como el CrossFit.
    .pic-big
      Gal(:pics="['assets/images/_MG_4016.jpg', 'assets/images/_MG_4187.jpg']" data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
    .gal
      Gal(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
    .text2
      Texto(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")
        h2 Una iniciadora entre sus pares
        p El Crossfit se ha convertido en uno de los entrenamientos funcionales que más auge a tenido este último tiempo, sobre en las mujeres. Se carateriza por ser una disciplina donde se realizan trabajos de fuerza y resistencia con una intensidad muy elevada, pero que puede ser adaptada a los distintos niveles de los participantes.
        p <strong>Stefannia Palma</strong>, quien practica CrossFit hace aproximadamente siete años, es una de las tantas mujeres que ya forma parte de este “estilo de vida”, como muchos quienes lo practican lo definen, y explica que se ha dado cuenta de este gran interés entre sus pares por realizar CrossFit. “Cuando yo partí las mujeres eramos muy pocas y ahora tu vas y ves a muchas mujeres que están felices de levantar, felices de sentirse fuertes”, dice Stefannia.
        p Si bien el cuerpo cambia al realizar ejercicio, las mujeres lo que más temen es perder su feminidad, Stefannia explica que si bien crece musculatura, jamás quedarán igual que un hombre. “El crossfit muestra a una mujer más femenina, siempre en las competencias las chicas están arregladas, siempre están maquilladas, con petos de colores, ropa que combina, se ven bastante bien”, destaca la cossfitera.
        p Skechers, entendiendo este crecimiento de mujeres en el deporte, presenta su línea Sport, que cuenta con zapatillas con plantillas memory Foam, para que los entrenamientos sean mucho más cómodos. Además, creó una nueva línea de ropa deportiva Skechers Performance.
        p Encuentra todos sus modelos en tiendas Skechers y <a href="https://www.skechers.cl">Skechers.cl</a>
    .video
      Video(data-aos="fade-right" data-aos-delay="300" data-aos-once="true")

</template>

<script>
  import Texto from '@/components/skechers/Texto'
  import Pic from '@/components/skechers/Pic'
  import Gal from '@/components/skechers/Gal'
  import Video from '@/components/skechers/Video'

  export default  {
    name: 'crossfit',
    props: [],
    components: {
      Texto,
      Pic,
      Gal,
      Video
    },
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">

  h1{
    color: #fb2850;
    text-transform: uppercase;
    font-family: 'AvantGarde';
    @include fluid-type(360px, 1440px, 70px, 224px);
    line-height: 90%;
    padding: 0;
    margin: 2rem 0;
    grid-column: 1 / -1;
    position: relative;
    z-index: 2;
    text-align: center;
    &:after,
    &:before{
      content: '';
      position: absolute;
      height: 30px;
      width: 170px;
      background-color: #fb2850;
      @media screen and (max-width: 700px){
        height: 10px;
        width: 80px;
      }
    }
    &:after{
      bottom: calc(100% - 0.5rem);
      right: 0;
      @media screen and (max-width: 700px){
        bottom: calc(100% + 0.5rem);
      }
    }
    &:before{
      top: calc(100% - 0.5rem);
      left: 0;
      @media screen and (max-width: 700px){
        top: calc(100% + 0.5rem);
      }
    }
  }

  .crossfit {
    display: grid;
    grid-template-columns: repeat(12, 1fr);
    width: 100%;
    grid-gap: 1rem;
    @media screen and (max-width: 700px){
      padding: 0 1rem;
    }
  }

  .text1{
    grid-column: 2 / 6;
    @media screen and (max-width: 700px){
      grid-column: 1 / -1;
    }
  }

  .pic-big{
    grid-column: 7 / -1;
    margin-top: -5rem;
    @media screen and (max-width: 700px){
      grid-column: 1 / -1;
      // display: none;
    }
  }

  .gal{
    grid-column: 2 / 6;
    @media screen and (max-width: 700px){
      grid-column: 1 / -1;
      // display: none;
    }
  }
  .video {
    grid-column: 1 / -1;
  }
  .text2{
    grid-column: 7 / -2;
    @media screen and (max-width: 700px){
      grid-column: 1 / -1;
    }
  }

</style>
